export default __webpack_public_path__ + "static/media/sectionTwo2.cb8a99b2.png";